import Component from '../inherited/Component'

export default class AlsoChange extends Component {
    constructor (elem, theme, options, ctx) {
      super(elem, theme, options, ctx)
      this._linkedElem = document.querySelector(this._options.target)
    }

    async mount () {
      this._elem.addEventListener('change', e => {
        this._linkedElem.value = this._elem.value
        this._linkedElem.dispatchEvent(new Event('change'))
        if(this._options.submitForm) {
            if(this._linkedElem.closest('form')) {
                this._linkedElem.closest('form').submit()
            }
        }
      })
    }

}